// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { RadioGroup, Radio } from 'informed';

import {
  addTBTest,
  deleteTBTest,
  updateTBTest,
} from '../../../actions/testingActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';

type Props = {
  tbTests: Object[],
  activePatientId: string,
  addTBTest: Function,
  deleteTBTest: Function,
  updateTBTest: Function,
}

class TBTestsComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    this.props.deleteTBTest(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    this.props.updateTBTest(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    this.props.addTBTest(this.props.activePatientId, formData.values);
  }

  render() {
    let { tbTests } = this.props;
    tbTests = tbTests.map((item, index) => ({ testNum: tbTests.length - index, ...item }));

    const columns = [
      {
        Header: '',
        id: 'index',
        cell: item => `Test #${item.testNum ? item.testNum : ''}`,
        width: 80,
      },
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
        editCell: item => <DateText field='date' item={item} />,
      },
      {
        Header: 'Type',
        id: 'type',
        editCell: item => (
          <RadioGroup field='type' initialValue={item.type}>
            <Radio value={'PPD Skin Test'} />PPD Skin Test
            <br />
            <Radio value={'IGRA Blood Test'} />IGRA Blood Test
            <br />
            <Radio value={'Sputum Smear Test'} />Sputum Smear Test
          </RadioGroup>
        ),
      },
      {
        Header: 'Result',
        id: 'positive',
        editCell: item => (
          <RadioGroup field='positive' initialValue={item.positive}>
            <Radio value={'Positive'} />Positive
            <br />
            <Radio value={'Negative'} />Negative
            <br />
            <Radio value={'Unknown'} />Unknown
          </RadioGroup>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        data={tbTests}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}

const mapStateToProps = state => ({
  tbTests: state.patient.data.testing.tbTests,
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addTBTest:
    (patientId, tbTest) => dispatch(addTBTest(patientId, tbTest)),
  deleteTBTest:
    (patientId, tbTestId) => dispatch(deleteTBTest(patientId, tbTestId)),
  updateTBTest:
    (patientId, tbTest) => dispatch(updateTBTest(patientId, tbTest)),
});

const TBTests = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TBTestsComponent);

export default TBTests;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/TBTests.jsx